import React, { useState } from 'react';
import {
  IBucketListItem,
  BucketListRegion
} from '../../../../Models/bucket-list/bucket-list.model';
import BucketListItemCard from './bucket-list-item-card';

type Props = {
  region: BucketListRegion;
  items: IBucketListItem[];
  layout: 'horizontal' | 'vertical';
  onEdit: (item: IBucketListItem) => void;
  onRemove: (itemId: string) => void;
  onAddToTrip: (item: IBucketListItem) => void;
};

const BucketListRegionGroup: React.FC<Props> = ({
  region,
  items,
  layout,
  onEdit,
  onRemove,
  onAddToTrip
}) => {
  const [isCollapsed, setIsCollapsed] = useState(false);

  if (layout === 'horizontal') {
    return (
      <div className='bl-region-column'>
        <div className='bl-region-column__header'>
          <h2 className='bl-region-group__title font-libre'>{region}</h2>
          <span className='badge bg-secondary bl-region-count-badge'>
            {items.length}
          </span>
        </div>
        <div className='bl-region-column__items'>
          {items.map((item) => (
            <BucketListItemCard
              key={item.id}
              item={item}
              onEdit={onEdit}
              onRemove={onRemove}
              onAddToTrip={onAddToTrip}
            />
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className='bl-region-group'>
      <div
        className='bl-region-group__header'
        onClick={() => setIsCollapsed(!isCollapsed)}
      >
        <h2 className='bl-region-group__title font-libre'>{region}</h2>
        <span className='badge bg-secondary bl-region-count-badge'>
          {items.length}
        </span>
        <button
          className='bl-region-collapse-btn'
          aria-label='Toggle region'
        >
          {isCollapsed ? '▸' : '▾'}
        </button>
      </div>
      {!isCollapsed && (
        <div className='bl-region-group__items'>
          {items.map((item) => (
            <BucketListItemCard
              key={item.id}
              item={item}
              onEdit={onEdit}
              onRemove={onRemove}
              onAddToTrip={onAddToTrip}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default BucketListRegionGroup;
